import { TravelKitService } from "src/app/shared/services/travel-kit.service";

/** Same payload shape as travel-kit-modify enqueueSubSectionSavePromises → updateMedia for videos. */
export function persistExistingVideoThumbnail(
  travelKitService: TravelKitService,
  media: any,
  subSectionIdFallback?: number
): void {
  if (!travelKitService || !media) {
    return;
  }
  const mediaId = Number(media.id);
  if (!Number.isFinite(mediaId) || mediaId <= 0) {
    return;
  }
  const thumbnail = typeof media.thumbnail === "string" ? media.thumbnail.trim() : "";
  if (!thumbnail || thumbnail === "data:," || thumbnail.startsWith("data:")) {
    return;
  }
  const subSectionId = media.subSectionId != null ? media.subSectionId : subSectionIdFallback;
  if (subSectionId == null || subSectionId === "") {
    return;
  }

  const mediaData = {
    type: media.type || "video",
    url: media.url || "",
    width: media.width || 0,
    height: media.height || 0,
    fileName: media.fileName || "",
    size: media.size || 0,
    thumbnail,
    subSectionId,
  };

  travelKitService.updateMedia(mediaData, mediaId).subscribe(
    () => undefined,
    () => undefined
  );
}
